"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Checkbox = void 0;
var react_1 = __importDefault(require("react"));
require("./checkbox.scss");
exports.Checkbox = function (_a) {
    var isSelected = _a.isSelected, onSelect = _a.onSelect, isDisabled = _a.isDisabled, name = _a.name;
    var modifierClasses = [];
    if (isSelected) {
        modifierClasses.push("c-checkbox--selected");
    }
    if (isDisabled) {
        modifierClasses.push("c-checkbox--disabled");
    }
    return (react_1.default.createElement("div", __assign({ "data-testid": "checkbox-test-id", className: "c-checkbox " + modifierClasses.join(" "), onClick: function () { return !isDisabled && onSelect(); }, role: "checkbox", "aria-checked": isSelected }, (name ? { name: name } : {})), isSelected && react_1.default.createElement("img", { src: require("../../../assets/icons/check-white-icn.svg"), alt: "checkmark" })));
};
//# sourceMappingURL=Checkbox.js.map